
import { TextInput, BooleanInput, FormDataConsumer, email, required, useRecordContext } from 'react-admin';
import ResetPasswordButton from './ResetPassword/ResetPasswordButton';
import { lowerTrimString } from '../../../normalize';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import DeleteUserButton from './DeleteUser/DeleteUserButton';

const widthInputs = { width: '260px' };
const validateEmail = [email(), required()];
const validateRequired = required();

const UserLoginContact = ({ edit }) => {
  const record = useRecordContext();
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <label style={{ fontWeight: 'bold', marginBottom: '16px' }}>Login / Contato</label>
      <FormDataConsumer>
        {({ formData }) => {
          if (edit && typeof formData?.isLoginLead ==='undefined') {
            return (
              <Box minHeight="56px" width={widthInputs.width}>
                <Skeleton variant="rectangular" width={widthInputs.width} height={40} style={{ borderRadius: 4 }} />
              </Box>
            );
          }
          return (
            <TextInput
              style={widthInputs}
              placeholder="ex: nome@rxpro.com.br"
              label="E-mail"
              source="email"
              validate={validateEmail}
              resettable
              type="email"
              parse={lowerTrimString}
              disabled={formData?.isLoginSocial}
            />
          );
        }}
      </FormDataConsumer>
      {edit && (
        <FormDataConsumer>
          {({ formData }) => {
            if (typeof formData?.isLoginLead === 'undefined') {
              return (
                <Box minHeight="36px" width={widthInputs.width}>
                  <Skeleton variant="rectangular" width={widthInputs.width} height={32} style={{ borderRadius: 4 }} />
                </Box>
              );
            }
            const currentEmail = (typeof formData?.email === 'string' ? formData.email : '').trim();
            const originalEmail = (typeof record?.email === 'string' ? record.email : '').trim();
            const emailEdited = !!(edit && record && currentEmail !== originalEmail);
            return (
              <ResetPasswordButton
                userId={formData?.id}
                email={formData?.email}
                isLoginLead={formData?.isLoginLead}
                isLoginSocial={formData?.isLoginSocial}
                emailEdited={emailEdited}
              />
            );
          }}
        </FormDataConsumer>
      )}
      {!edit && (
        <TextInput
          style={widthInputs}
          label="Senha"
          source="password"
          validate={validateRequired}
          resettable
        />
      )}
      <div style={{ marginTop: '32px' }}>
        <label style={{ fontWeight: 'bold' }}>Perfil de Usuário</label>
        <div style={{ marginTop: '16px' }}>
          <BooleanInput
            label="Usuário para teste"
            source="isTestUser"
          />
          <FormDataConsumer>
            {({ formData }) => (
              <BooleanInput
                label="Usuário administrador"
                source="isAdminUser"
                defaultValue={formData.roleUser && formData.roleUser.name === 'administrator'}
              />
            )}
          </FormDataConsumer>
          {edit && (
            <FormDataConsumer>
              {({ formData }) => (
                <DeleteUserButton userId={formData?.id} email={formData?.email} />
              )}
            </FormDataConsumer>
          )}
        </div>
      </div>
    </div>
  );
} 

export default UserLoginContact;
